import {Component, OnInit} from '@angular/core';
import {UserService} from '../shared/model/user.service';
import {Observable} from 'rxjs';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {AuthService} from '../shared/security/auth.service';
import {User} from '../shared/model/user'
import {ViewChild} from '@angular/core';
import {UserDetailComponent} from '../user-detail/user-detail.component';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {

    @ViewChild(UserDetailComponent)
    public readonly modal1: UserDetailComponent;

    users$: Observable<User[]>;
    clubId$: BehaviorSubject<string>;

    inEditMode: boolean = false;
    inDeleteMode: boolean = false;
    inResetMode: boolean = false;

    selectedRow: number;
    selectedUser: User;

    dbPath: string = '';
    confirmationTitle: string = '';
    confirmationText: string = '';
    email: string = '';

    permission = {
      'ultrasuperuser': 6,
      'superuser': 5,
      'superadmin': 4,
      'distributor': 4,
      'admin': 3,
      'steward': 2,
      'trainer': 1,
      'player': 0
    };

    constructor(private userService: UserService, private authService: AuthService, private translate: TranslateService) {
    }

    ngOnInit() {
        // TODO: fix authservice authentication
        let clubIdForUser = this.authService.getClubIdForUser();
        this.clubId$ = new BehaviorSubject(clubIdForUser);
        this.users$ = this.userService.findUsersForClub(clubIdForUser);
    }

    setSelectedUser(row: number, userId: string, role: string) {
      this.selectedRow = row;
      this.userService.findUserByUid(userId).subscribe(
          user => this.selectedUser = user,
          error => console.error
      );

      //console.log(Date.now());
      setTimeout(() => {
        const userRole = this.authService.getUserRole();
        const userPermission = this.permission[userRole];
        const rolePermission = this.permission[role];
        //console.log(`logged in user permission: ${userPermission}, this user permission: ${rolePermission}`);
        if ( userPermission >= rolePermission ) {
          this.inEditMode = true;
          this.inDeleteMode = false;
          this.inResetMode = false;
        }
      }, 1000);

    }

    resetPassword(row: number, email: string) {
      this.email = email;
      this.selectedRow = row;

      this.translate.get('l.resetpassword').subscribe((res: string) => {
        this.confirmationTitle = res;
        this.translate.get('l.resetpasswordmsg').subscribe((res2: string) => {
          this.confirmationText = res2 + " " + email + "?";
          //console.log(this.confirmationText);
          this.inDeleteMode = false;
          this.inEditMode = false;
          this.inResetMode = true;
        });
      });
    }

    removeSelectedUser(row: number, userId: string, userName: string) {
      this.selectedRow = row;
      this.userService.findUserByUid(userId).subscribe(
          user => this.selectedUser = user,
          error => console.error
      );

      this.translate.get('l.deleteuser').subscribe((res: string) => {
        this.confirmationTitle = res;
        this.translate.get('l.deleteusermsg').subscribe((res2: string) => {
          this.confirmationText = res2 + " " + userName + "?";
          this.inDeleteMode = true;
          this.inEditMode = false;
          this.inResetMode = false;
        });
      });
    }

    processConfirmation(result: boolean) {
        if(result) {
          if(this.inResetMode) {
            this.authService.resetPassword(this.email);
            this.translate.get('s.resetpassword').subscribe((res: string) => {
              alert(res);
            })
          } else if (this.inDeleteMode) {
            this.userService.deleteUser(this.selectedUser.$key);
          }
        }
        this.inResetMode = false;
        this.inDeleteMode = false;
        this.inEditMode = false;
    }

  getUserLastLoggedIn( lastLoggedIn: string ): string {
    if (lastLoggedIn != null) {
      const lli = Number( lastLoggedIn );
      const lang = this.translate.currentLang;

      let locale = 'nl-NL';
      if ( lang === 'en' ) {
        locale = 'en-GB';
      } else if ( lang === 'de' ) {
        locale = 'de-DE';
      } else if ( lang === 'fr' ) {
        locale = 'fr-BE';
      }

      if ( lli > 1 ) {
        //console.log(lli);
        const n = new Date( lli );
        return n.toLocaleString( locale );

      } else {
        return lastLoggedIn;
      }

    } else {
      return "";
    }
  }

}
